import { DurationViewer } from '~/common/components/defaultUIComponents/DurationViewer';
import useTranslate from '~/common/utils/translate';
import { useOrderedProjectTimes } from '../utils';
import { HStack } from '@chakra-ui/react';

export function TotalCalculatedTimes() {
  const t = useTranslate();
  const { totalSeconds, openSeconds } = useOrderedProjectTimes();
  return (
    <HStack>
      <DurationViewer
        label={t('totalSeconds')}
        durationInSeconds={totalSeconds}
      />
      <DurationViewer
        label={t('openSeconds')}
        durationInSeconds={openSeconds}
      />
    </HStack>
  );
}
